import { createStore } from "vuex";
import auth from "./auth";
import theme from "./theme";
import salary from "./salary";
import notification from "./notification";

export default createStore({
  modules: {
    auth,
    theme,
    salary,
    notification,
  },
});
